// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1ys9P","itemTitle":"ClientEmergencyInfo_itemTitle__2Gjl8","itemText":"ClientEmergencyInfo_itemText__20kHC"};